import { container } from '@eureka/services'
import type { ICoreDataWrapper } from '@eureka/services/src/exception';
import type { NavHistoryResponse } from '../../types'
import psHttp from '@patsnap/common-ps-http';

export function getHistoryList() {
    return container.RnDHttp.get<ICoreDataWrapper<NavHistoryResponse>>({
        // @ts-ignore
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/history/records`,
        params: {
            page: 1,
            pageSize: 100,
            type: 'playbook',
            duration: 1,
            tzOffset: -(new Date()).getTimezoneOffset(),
        },
    }).then((res) => {
        return res.data
    })
}

export function removeHistory(historyId: string) {
    return container.RnDHttp.delete<ICoreDataWrapper<boolean>>({
        // @ts-ignore
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/history`,
        data: {
            type: 'playbook',
            history_ids: [historyId],
        },
    }).then((res) => {
        return res.status
    })
}

export function removeAllRecords() {
    return container.RnDHttp.delete<ICoreDataWrapper<boolean>>({
        // @ts-ignore
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/history`,
        data: {
            type: 'all',
        },
    }).then((res) => {
        return res.status
    })
}

export function getSessionsList(query?: string) {
    return psHttp<any>({
        method: 'GET',
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/api/eureka/sessions`,
        // @ts-ignore
        // url: 'http://qa-s-core-eureka-agent.patsnap.info/api/eureka/sessions',
        params: {
            page: 1,
            pageSize: 100,
            query,
        },
    }).then((res: any) => {
        return res.data
    })
        .catch((err: any) => {
            return err;
        });
}
